export const PROFILE_TYPES = {
	1: "Procurer",
	2: "Bidder",
	3: "Procurer and Bidder",
	8: "Sponsored Bidder",
};

export const ACCOUNT_TYPES_GROUPING = {
	procurer: "procurer",
	bidder: "bidder",
	bidderAndProcurer: "bidder_procurer",
};
